import { fieldWorkspaceJobSchema, fieldWorkspaceStatusSchema } from '@mio/shared';

import { SignOutBlockedError } from '@/features/auth/sign-out-blocked-error';
import { apiRequest } from '@/shared/api/client';

import { fieldEditorSessionFor } from './field-workspace-session';
/** Keep the editor mounted until its acknowledged bytes are durably backed up. */
export async function prepareFieldSignOut() {
  const state = await apiRequest('/field/workspace', fieldWorkspaceStatusSchema);
  if (!state.enabled || state.selection !== 'field' || state.state === 'stopped') return;
  if (state.operation && ['pending', 'running'].includes(state.operation.status))
    throw new SignOutBlockedError(
      'Wait for the Workbench workspace operation, then sign out again.',
    );
  if (state.state !== 'ready' || !state.workspaceId || !state.context)
    throw new SignOutBlockedError(
      'Open Workbench and resolve the workspace status before signing out.',
    );
  try {
    let operation = await apiRequest('/field/workspace/commands', fieldWorkspaceJobSchema, {
      method: 'POST',
      body: {
        requestId: crypto.randomUUID(),
        action: 'save',
        expectedGeneration: state.generation,
        editorSessionId: await fieldEditorSessionFor(state.context),
      },
    });
    const signal = AbortSignal.timeout(150000);
    while (['pending', 'running'].includes(operation.status)) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      signal.throwIfAborted();
      operation = await apiRequest(
        `/field/workspace/operations/${operation.id}`,
        fieldWorkspaceJobSchema,
        { signal },
      );
    }
    if (operation.status !== 'completed') throw new Error('Workbench save failed');
  } catch {
    throw new SignOutBlockedError(
      'Could not confirm your Workbench code was backed up. Keep the IDE open and retry its save before signing out.',
    );
  }
}
